import { gql } from '@apollo/client';

export const GET_ORGANIZATION_TREE = gql`
  query GET_ORGANIZATION_TREE($input: OrganizationTreeInput!) {
    getOrganizationTree(input: $input) {
      organizationId
      name
      contactPhone
      contactEmail
      address

      createdBy
      isDisabled
      isDeleted
      createdAt
      updatedAt
      brands {
        brandId
        name
        organizationId
        countries
        isDeleted
        isDisabled
        createdAt
        updatedAt
        countryList {
          _id
          name
          currency
          countryCode
          dialingCode
          timezone
          flag
          primaryLanguage
          secondaryLanguages
          isDeleted
          isDisabled
          createdAt
          updatedAt
          stores {
            storeId
            name
            brandId
            organizationId
            area
            address
            createdBy
            countryCode
            isDeleted
            isDisabled
            isEcommerce
            createdAt
            updatedAt
          }
        }
      }
    }
  }
`;

export const CREATE_ORGANIZATION = gql`
  mutation CREATE_ORGANIZATION($input: OrganizationInput!) {
    createOrganization(input: $input) {
      organizationId
      name
      createdBy
      isDisabled
      isDeleted
      createdAt
    }
  }
`;

export const GET_ORGANIZATIONS = gql`
  query GET_ORGANIZATIONS($input: OrganizationsInput!) {
    organizations(input: $input) {
      organizationId
      name
      createdBy
      isDisabled
      isDeleted
      createdAt
      updatedAt
      description
      address
      contactEmail
      contactPhone
      country
    }
  }
`;

export const GET_COUNTRIES = gql`
  query GET_COUNTRIES($input: CountriesInput!) {
    countries(input: $input) {
      _id
      name
      currency
      countryCode
      dialingCode
      timezone
      flag
      primaryLanguage
      secondaryLanguages
      isDeleted
      isDisabled
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_OR_UPDATE_COUNTRY = gql`
  mutation CREATE_OR_UPDATE_COUNTRY($input: CountryInput!) {
    createOrUpdateCountry(input: $input) {
      _id
      name
      currency
      countryCode
      dialingCode
      timezone
      flag
      primaryLanguage
      secondaryLanguages
      isDeleted
      isDisabled
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_OR_UPDATE_BRAND = gql`
  mutation CREATE_OR_UPDATE_BRAND($input: BrandInput!) {
    createOrUpdateBrand(input: $input) {
      brandId
      name
      organizationId
      countries
      isDeleted
      isDisabled
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_OR_UPDATE_STORE = gql`
  mutation CREATE_OR_UPDATE_STORE($input: StoreInput!) {
    createOrUpdateStore(input: $input) {
      storeId
      name
      brandId
      organizationId
      area
      address
      createdBy
      countryCode
      isDeleted
      isDisabled
      isEcommerce
      createdAt
      updatedAt
    }
  }
`;

export const GET_BRANDS = gql`
  query GET_BRANDS($input: BrandsInput!) {
    brands(input: $input) {
      brandId
      name
      organizationId
      countries
      isDeleted
      isDisabled
      createdAt
      updatedAt
    }
  }
`;

export const GET_STORES = gql`
  query GET_STORES($input: StoresInput!) {
    stores(input: $input) {
      storeId
      name
      brandId
      organizationId
      area
      address
      createdBy
      countryCode
      isDeleted
      isDisabled
      isEcommerce
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_OR_UPDATE_PERMISSION = gql`
  mutation CREATE_OR_UPDATE_PERMISSION($input: PermissionInput!) {
    createOrUpdatePermission(input: $input) {
      permissionId
      name
      action
      subject
      conditions
      isDisabled
      isDeleted
      createdAt
      updatedAt
    }
  }
`;

export const GET_PERMISSIONS = gql`
  query GET_PERMISSIONS {
    permissions {
      permissionId
      name
      action
      subject
      conditions
      isDisabled
      isDeleted
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_OR_UPDATE_ROLE = gql`
  mutation CREATE_OR_UPDATE_ROLE($input: RoleInput!) {
    createOrUpdateRole(input: $input) {
      name
      roleId
      organizationId
      brandId
      description
      permissions {
        permissionId
        name
        subject
        action
        conditions
      }
      isDisabled
      isDeleted
      createdAt
      updatedAt
    }
  }
`;

export const GET_ROLES = gql`
  query getRoles($input: RolesInput!) {
    roles(input: $input) {
      totalPages
      totalRoles
      currentOffset
      roles {
        roleId
        organizationId
        brandId
        name
        description
        subject
        permissions {
          permissionId
          name
          subject
          action
          conditions
        }
        isDisabled
        isDeleted
        createdAt
        updatedAt
      }
    }
  }
`;

// Query to fetch a single organization by ID
export const GET_ORGANIZATION = gql`
  query GetOrganization($id: String!) {
    organization(id: $id) {
      id
      name
      createdAt
      updatedAt
    }
  }
`;

// Mutation to update an existing organization
export const UPDATE_ORGANIZATION = gql`
  mutation UpdateOrganization($input: UpdateOrganizationInput!) {
    updateOrganization(input: $input) {
      id
      name
      createdAt
      updatedAt
    }
  }
`;

// Mutation to delete an organization
export const DELETE_ORGANIZATION = gql`
  mutation DeleteOrganization($id: String!) {
    deleteOrganization(_id: $id) {
      id
      name
    }
  }
`;

// Mutation to toggle enable/disable status of an organization
export const TOGGLE_DISABLE_ORGANIZATION = gql`
  mutation ToggleDisableOrganization($input: OrganizationDisableInput!) {
    toggleDisableOrganization(input: $input) {
      id
      name
      isDisabled
    }
  }
`;
